import { render, staticRenderFns } from "./SharedParameters.vue?vue&type=template&id=27d3d28a&scoped=true"
import script from "./SharedParameters.vue?vue&type=script&lang=ts"
export * from "./SharedParameters.vue?vue&type=script&lang=ts"
import style0 from "./SharedParameters.vue?vue&type=style&index=0&id=27d3d28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d3d28a",
  null
  
)

export default component.exports